"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JsonParser = void 0;
/**
 * Worker code as a string for parsing JSON
 */
var workerCodeString = "\n  self.onmessage = function({ data }) {\n    const { jsonString, requestId } = data;\n    \n    try {\n      const parsedData = JSON.parse(jsonString);\n      self.postMessage({ status: 'success', data: parsedData, requestId });\n    } catch (error) {\n      self.postMessage({ status: 'error', error: error.message, requestId });\n    }\n  };\n";
// Size threshold for using direct parsing vs worker (characters)
// 10KB - safe for UI thread in browsers
var SMALL_STRING_THRESHOLD = 10000;
var JsonParser = /** @class */ (function () {
    function JsonParser() {
    }
    var _a;
    _a = JsonParser;
    JsonParser.worker = null;
    JsonParser.workerUrl = null;
    JsonParser.workerFailed = false;
    /**
     * Parse JSON string and return result as a Promise
     * Uses main thread for small strings and worker for larger ones
     * @param jsonString JSON string to parse
     * @returns Promise with parsed JSON data
     */
    JsonParser.parse = function (jsonString_1) {
        var args_1 = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args_1[_i - 1] = arguments[_i];
        }
        return __awaiter(void 0, __spreadArray([jsonString_1], __read(args_1), false), void 0, function (jsonString, threshold) {
            var _b;
            if (threshold === void 0) { threshold = SMALL_STRING_THRESHOLD; }
            return __generator(_a, function (_c) {
                switch (_c.label) {
                    case 0:
                        // For small strings parse directly in the main thread
                        if (jsonString.length < threshold) {
                            return [2 /*return*/, JSON.parse(jsonString)];
                        }
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, _a.parseInWorker(jsonString)];
                    case 2: return [2 /*return*/, _c.sent()];
                    case 3:
                        _b = _c.sent();
                        return [2 /*return*/, JSON.parse(jsonString)];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    JsonParser.parseInWorker = function (jsonString) {
        var requestId = Date.now().toString();
        _a.initWorker();
        if (_a.workerFailed) {
            return Promise.reject(new Error('Worker unavailable'));
        }
        return new Promise(function (resolve, reject) {
            var handleMessage = function (event) {
                if (event.data.requestId !== requestId)
                    return;
                _a.worker.removeEventListener('message', handleMessage);
                if (event.data.status === 'success') {
                    resolve(event.data.data);
                }
                else {
                    reject(new Error(event.data.error));
                }
            };
            _a.worker.addEventListener('message', handleMessage);
            _a.worker.postMessage({ jsonString: jsonString, requestId: requestId });
        });
    };
    JsonParser.initWorker = function () {
        try {
            var blob = new Blob([workerCodeString], {
                type: 'application/javascript'
            });
            _a.workerUrl = URL.createObjectURL(blob);
            _a.worker = new Worker(_a.workerUrl);
            _a.worker.onerror = function () { return (_a.workerFailed = true); };
        }
        catch (_b) {
            _a.workerFailed = true;
        }
    };
    JsonParser.dispose = function () {
        if (_a.worker) {
            _a.worker.terminate();
            _a.worker = null;
        }
        if (_a.workerUrl) {
            URL.revokeObjectURL(_a.workerUrl);
            _a.workerUrl = null;
        }
    };
    return JsonParser;
}());
exports.JsonParser = JsonParser;
